import React from 'react'

import * as S from './styles'
import { Text } from '@/components/text'

export type GlassmorphismCardProps = {
  /**
   * Background color of the card
   * @default ${theme.colors.black}
   *
   * @example
   * ```tsx
   * <GlassmorphismCard backgroundColor="#000" />
   * ```
   */
  backgroundColor?: string

  /**
   * Blur of the card
   *
   * @example
   * ```tsx
   * <GlassmorphismCard backdropFilter="blur(10px)" />
   * ```
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter
   *
   */
  backdropFilter?: string

  /**
   * Title of the card
   *
   * @example
   * ```tsx
   * <GlassmorphismCard title="Title" />
   * ```
   */
  title: string

  /**
   * Description of the card
   *
   * @example
   * ```tsx
   * <GlassmorphismCard description="Description" />
   * ```
   */
  description: string
}

export const GlassmorphismCard: React.FC<GlassmorphismCardProps> = ({
  backgroundColor,
  backdropFilter,
  title,
  description,
}) => (
  <S.Card backgroundColor={backgroundColor} backdropFilter={backdropFilter}>
    <Text size="h3" color="primary">
      {title}
    </Text>

    <Text size="b2" color="white">
      {description}
    </Text>
  </S.Card>
)
